import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decimalOnly',
})
export class DecimalOnlyPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): string {
    if (!value) {
      return '00';
    }

    if (typeof value !== 'string') {
      value = value + '';
    }

    const regex = /[^.]+$/;
    if (value.indexOf('.') !== -1) {
      const decimal = (regex as any).exec(value).toString();
      // Pad with zeros if less than 2 digits
      return decimal.padEnd(2, '0');
    }
    return '00';
  }
}
